/**
 * BUSINESS CONFIGURATION
 * ======================
 * This file contains all business-specific information for the e-commerce site.
 * Update these values with your client's business details.
 */

const businessConfig = {
  // ========================================
  // BUSINESS IDENTITY
  // ========================================
  business: {
    legalName: 'Xiluva Botanicals (Pty) Ltd',
    tradingName: 'Xiluva Botanicals',
    tagline: 'Natural Wellness & Botanical Products',
    description: 'Premium botanical products including herbal powders, teas, wellness supplements, natural skincare, yoni steaming herbs, and spiritual cleansing products. Connecting you with nature\'s healing power through traditional African botanicals and modern wellness solutions.',
  },

  // ========================================
  // CONTACT INFORMATION
  // ========================================
  contact: {
    phone: '+27726291554',
    phoneDisplay: '+27 72 629 1554', // Formatted for display
    email: 'info@xiluvabotanicals.co.za',
    notificationEmail: 'info@xiluvabotanicals.co.za', // Email for order notifications

    // WhatsApp
    whatsapp: {
      number: '+27726291554', // Include country code
      link: 'https://wa.me/message/OTB3V7QYDYCRM1',
      enableWhatsApp: true,
    },

    // Physical address
    address: {
      street: '',
      city: 'Pretoria',
      province: 'Gauteng',
      country: 'South Africa',
      full: 'Pretoria, South Africa',
    },

    // Business hours
    hours: {
      weekdays: 'Mon-Fri: 08:00-18:00, Sat: 08:00-17:00, Sun: 09:00-15:30',
      timezone: 'SAST', // South African Standard Time
      display: 'Mon-Fri: 08:00-18:00, Sat: 08:00-17:00, Sun: 09:00-15:30',
    },
  },

  // ========================================
  // PAYMENT INFORMATION
  // ========================================
  payment: {
    // Bank account details for EFT/Bank transfer
    bankAccount: {
      accountHolder: 'XILUVA BOTANICALS (PTY) LTD',
      bank: 'LYNNWOOD THE GROVE',
      accountNumber: '0000010260952603',
      branchCode: '', // Not provided, add if available
      accountType: 'CURRENT',
    },

    // Payment methods accepted
    paymentMethods: ['EFT', 'Bank Transfer'],

    // Payment instructions
    instructions: 'Please use your order number as the payment reference',
  },

  // ========================================
  // SOCIAL MEDIA
  // ========================================
  socialMedia: {
    facebook: {
      url: '',
      enabled: false,
    },
    instagram: {
      url: 'https://www.instagram.com/xiluvabotanicals?igsh=NDZiYW9memE2dTU4&utm_source=qr',
      username: '@xiluvabotanicals',
      enabled: true,
    },
    tiktok: {
      url: '',
      username: '',
      enabled: false,
    },
    twitter: {
      url: '',
      username: '',
      enabled: false,
    },
    linkedin: {
      url: '',
      enabled: false,
    },
  },

  // ========================================
  // SERVICES OFFERED
  // ========================================
  services: [
    'Herbal Powders & Supplements',
    'Wellness Teas',
    'Natural Skincare Products',
    'Yoni Steaming Herbs',
    'Spiritual Cleansing Products',
    'Weight Management Solutions',
  ],

  // ========================================
  // SHIPPING & DELIVERY
  // ========================================
  shipping: {
    // Default shipping information
    processingTime: '1-3 Days',

    // Shipping zones (can be expanded per client needs)
    zones: [
      {
        name: 'PAXI Standard Bag',
        cost: 60,
        delivery: '7-9 days',
        costExpress: 110,
        deliveryExpress: '3-5 days',
      },
      {
        name: 'PAXI Large Bag',
        cost: 110,
        delivery: '7-9 days',
        costExpress: 140,
        deliveryExpress: '3-5 days',
      },
      {
        name: 'Postnet',
        cost: 109,
        delivery: '2-3 days',
      },
      {
        name: 'The Courier Guy (Home Delivery)',
        cost: 140,
        delivery: '1-3 days',
      },
      {
        name: 'ARAMEX (Home Delivery)',
        cost: 120,
        delivery: '2-5 days',
      },
      {
        name: 'PUDO (Locker & Home Delivery)',
        cost: 70,
        costRange: 'R70 - R200',
        delivery: 'Varies',
        note: 'Price depends on size - please enquire first',
      },
    ],

    // Pickup options
    localPickup: {
      enabled: true,
      location: 'Pretoria, South Africa',
      instructions: 'Contact us to arrange pickup',
    },
  },

  // ========================================
  // POLICIES
  // ========================================
  policies: {
    returns: {
      enabled: true,
      period: '14 days',
      conditions: 'Items must be unused and in original packaging. Custom/personalized items may not be eligible for returns.',
    },
    refunds: {
      enabled: true,
      processingTime: '5-7 business days',
    },
    privacy: {
      dataRetention: '7 years (for tax purposes)',
      cookiesEnabled: true,
    },
  },

  // ========================================
  // TRUST BADGES & GUARANTEES
  // ========================================
  trustBadges: [
    {
      icon: 'Shield',
      text: 'Secure Checkout',
    },
    {
      icon: 'Award',
      text: 'Quality Guaranteed',
    },
  ],

  // ========================================
  // CUSTOMER CARE LINKS
  // ========================================
  customerCareLinks: [
    { label: 'Contact Us', path: '/contact' },
    { label: 'Shipping Info', path: '/shipping' },
    { label: 'Returns Policy', path: '/returns' },
  ],
};

export default businessConfig;
